import produce from "immer";

import { messageCheckerActionNames, MessageCheckerActionTypes } from ".";
import { MessageCheckerState } from "./messageCheckerState";

const MAX_API_FAILURES = 10;
export const messageCheckerReducer = (
    state: MessageCheckerState,
    action: MessageCheckerActionTypes
): MessageCheckerState =>
    produce(state, draft => {
        switch (action.type) {
            case messageCheckerActionNames.UPDATE_UNREAD: {
                if (action.payload.count < 0) return;
                draft.newUnreadSignal =
                    action.payload.count - state.unreadCount > 0
                        ? state.newUnreadSignal + 1
                        : state.newUnreadSignal;
                draft.unreadCount = action.payload.count;
                break;
            }
        }
    });
